import { FC, useEffect, useState } from 'react';

import { CompanyDetailType } from '@type-def_iqfu/CompanyType';

import styles from './RightColumnSaleCases.module.scss';

type Props = {
  companyData: CompanyDetailType;
};

const RightColumnSaleCases: FC<Props> = ({ companyData }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const totalSaleCases = companyData.iqfu.total_count + companyData.cloud.total_count;
  const totalRecentSaleCases = companyData.iqfu.recent_count + companyData.cloud.recent_count;

  useEffect(() => {
    setIsOpen(false);
  }, [companyData]);

  return (
    <>
      <div className={styles.right_column_container_item}>
        <div className={styles.right_column_container_sale_cases_area}>
          <p className={styles.right_column_container_sale_cases_area_title}>売却実績登録数</p>
        </div>
        <div className={styles.right_column_container_sale_cases_wrapper}>
          <div className={styles.right_column_container_value}>
            <div className={styles.right_column_container_value_label}>
              <p className={`${styles.right_column_container_value_label} ${styles.bold}`}>累計実績登録数</p>
              <p>{totalSaleCases}件</p>
            </div>
            <div className={styles.right_column_container_value_label}>
              <p className={`${styles.right_column_container_value_label} ${styles.bold}`}>直近3ヶ月以内</p>
              <p>{totalRecentSaleCases}件</p>
            </div>
            <div className={styles.right_column_container_value_label}>
              <p className={`${styles.right_column_container_value_label} ${styles.bold}`}>詳細情報</p>
              <a
                className={styles.sale_cases_detail_link}
                onClick={() => {
                  setIsOpen((prev) => !prev);
                }}
              >
                {isOpen ? '閉じる' : '開く'}
              </a>
            </div>
          </div>
          {isOpen && (
            <div className={styles.right_column_container_sale_cases_detail_wrapper}>
              <p className={styles.right_column_container_sale_cases_detail_wrapper_title}>イクラ不動産</p>
              <div className={styles.right_column_container_value_label}>
                <p>累計実績登録数</p>
                <p>{companyData.iqfu.total_count}件</p>
              </div>
              <div className={styles.right_column_container_value_label}>
                <p>直近3ヶ月以内</p>
                <p>{companyData.iqfu.recent_count}件</p>
              </div>
              <p className={styles.right_column_container_sale_cases_detail_wrapper_title}>イクラウド</p>
              <div className={styles.right_column_container_value_label}>
                <p>累計実績登録数</p>
                <p>{companyData.cloud.total_count}件</p>
              </div>
              <div className={styles.right_column_container_value_label}>
                <p>直近3ヶ月以内</p>
                <p>{companyData.cloud.recent_count}件</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default RightColumnSaleCases;
